import React from "react";
import axios from "axios";
import PropTypes from "prop-types";
import TldrBase from "../TldrLogin/TldrBase";
import { withRouter } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import { connect } from "react-redux";
import * as yup from "yup";
import { RESET_PASSWORD_CONFIRMATION } from "../_actions/endpoints";
import {
  PASSWORD_RESET_SUCCESS,
  PASSWORD_RESET_FAILURE,
} from "../_utils/routes";
import {
  Button,
  Divider,
  Flex,
  FormControl,
  FormErrorMessage,
  Input,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

const validationSchema = (t) =>
  yup.object({
    new_password1: yup
      .string()
      .min(8, t("reset_password.password_min"))
      .required(t("reset_password.password_required")),
    new_password2: yup
      .string()
      .required(t("reset_password.password_required"))
      .oneOf(
        [yup.ref("new_password1"), null],
        t("reset_password.passwords_match")
      ),
  });

const ResetPasswordForm = ({ props }) => {
  const { t } = useTranslation(["auth"]);
  return (
    <Formik
      initialValues={{ new_password1: "", new_password2: "" }}
      validationSchema={validationSchema(t)}
      onSubmit={(values, { setSubmitting, setErrors, resetForm }) => {
        var userData = {
          uid: props.match.params.uid,
          token: props.match.params.token,
          new_password1: values.new_password1,
          new_password2: values.new_password2,
        };
        axios
          .post(RESET_PASSWORD_CONFIRMATION, userData)
          .then((res) => {
            setSubmitting(false);
            resetForm({ values: "" });
            props.history.push(PASSWORD_RESET_SUCCESS);
          })
          .catch((error) => {
            setSubmitting(false);
            props.history.push(PASSWORD_RESET_FAILURE);
          });
      }}
    >
      {({ isSubmitting }) => (
        <TldrBase
          subheading={t("reset_password.subheading")}
          heading={t("reset_password.heading")}
        >
          <Divider />
          <Form>
            <Field name="new_password1">
              {({ field, form }) => (
                <FormControl
                  mt={2}
                  isInvalid={
                    form.errors.new_password1 && form.touched.new_password1
                  }
                >
                  <Input
                    size={"lg"}
                    fontSize="inherit"
                    type="password"
                    {...field}
                    name="new_password1"
                    placeholder={t("reset_password.password")}
                  />
                  <FormErrorMessage>
                    {form.errors.new_password1}
                  </FormErrorMessage>
                </FormControl>
              )}
            </Field>
            <Field name="new_password2">
              {({ field, form }) => (
                <FormControl
                  mt={3}
                  isInvalid={
                    form.errors.new_password2 && form.touched.new_password2
                  }
                >
                  <Input
                    size={"lg"}
                    fontSize="inherit"
                    type="password"
                    {...field}
                    name="new_password2"
                    placeholder={t("reset_password.confirm_password")}
                  />
                  <FormErrorMessage>
                    {form.errors.new_password2}
                  </FormErrorMessage>
                </FormControl>
              )}
            </Field>
            <Flex mt={3} justify="right">
            <Button
              type="submit"
              disabled={isSubmitting}
              size="lg"
              variant="solid"
              isLoading={isSubmitting}
            >
              {t("reset_password.reset")}
            </Button>
            </Flex>
          </Form>
        </TldrBase>
      )}
    </Formik>
  );
};

export const ResetPassword = (props) => {
  return <ResetPasswordForm props={props}></ResetPasswordForm>;
};

ResetPassword.prototypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors,
});

export default connect(mapStateToProps, null)(withRouter(ResetPassword));
